export enum SystemBoardId {
  Favorites = 'board.fav',
}

export const SYSTEM_BOARDS_TRANSLATIONS = {
  [SystemBoardId.Favorites]: 'system-board.favorites',
};
